import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-charcoal" data-id="element-71">
    <h3 className="font-playfair text-2xl text-burgundy mb-4" data-id="element-72">
      Politique de Confidentialité
    </h3>
    <p data-id="element-73">
      <strong data-id="element-74">Dernière mise à jour :</strong> Mars 2026
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-75">1. Collecte des informations</h4>
    <p data-id="element-76">
      Nous recueillons des informations lorsque vous passez une commande sur
      notre site. Les informations recueillies incluent votre nom, votre adresse
      e-mail et vos informations de paiement.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-77">
      2. Utilisation des informations
    </h4>
    <p data-id="element-78">Les informations que nous recueillons sont utilisées pour :</p>
    <ul className="list-disc pl-6 space-y-1" data-id="element-79">
      <li data-id="element-80">Traiter et livrer votre commande (envoi des guides par email)</li>
      <li data-id="element-81">Vous envoyer des communications relatives à votre achat</li>
      <li data-id="element-82">Améliorer notre service et votre expérience</li>
    </ul>

    <h4 className="font-semibold text-lg mt-6" data-id="element-83">
      3. Protection des informations
    </h4>
    <p data-id="element-84">
      Nous mettons en œuvre des mesures de sécurité pour protéger vos
      informations personnelles. Vos données de paiement sont traitées de
      manière sécurisée et ne sont pas stockées sur nos serveurs.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-85">4. Cookies</h4>
    <p data-id="element-86">
      Nous utilisons des cookies pour améliorer votre expérience de navigation
      et analyser le trafic de notre site.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-87">5. Partage des informations</h4>
    <p data-id="element-88">
      Nous ne vendons, n'échangeons ni ne transférons vos informations
      personnelles à des tiers, sauf pour les besoins de livraison de votre
      commande.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-89">6. Vos droits</h4>
    <p data-id="element-90">
      Vous avez le droit d'accéder, de modifier ou de supprimer vos données
      personnelles à tout moment en nous contactant par email.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-charcoal" data-id="element-91">
    <h3 className="font-playfair text-2xl text-burgundy mb-4" data-id="element-92">
      Conditions Générales de Vente
    </h3>
    <p data-id="element-93">
      <strong data-id="element-94">Dernière mise à jour :</strong> Mars 2026
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-95">1. Objet</h4>
    <p data-id="element-96">
      Les présentes conditions générales régissent la vente du pack numérique
      "RE-NAISSANCE" et de ses bonus associés, constitués de guides au format
      PDF.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-97">2. Produits</h4>
    <p data-id="element-98">
      Les produits vendus sont des contenus numériques (ebooks en format PDF)
      livrés par email immédiatement après le paiement. Aucun produit physique
      n'est expédié.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-99">3. Prix</h4>
    <p data-id="element-100">
      Le prix du pack est indiqué en dollars canadiens ($) sur la page de vente.
      Le prix est susceptible de changer sans préavis, mais le prix applicable
      est celui affiché au moment de la commande.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-101">4. Paiement et livraison</h4>
    <p data-id="element-102">
      Le paiement est effectué en ligne de manière sécurisée. Après confirmation
      du paiement, vous recevez un email contenant les liens de téléchargement
      de tous les guides dans un délai de 2 minutes.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-103">5. Garantie de remboursement</h4>
    <p data-id="element-104">
      Nous offrons une garantie de remboursement de 30 jours. Si vous n'êtes pas
      satisfaite après avoir appliqué la méthode pendant 30 jours, vous pouvez
      demander un remboursement intégral par email. Vous conservez l'accès à
      tous les guides.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-105">6. Propriété intellectuelle</h4>
    <p data-id="element-106">
      Tous les contenus du pack RE-NAISSANCE sont protégés par le droit
      d'auteur. L'achat vous confère un droit d'utilisation personnel et non
      transférable. Toute reproduction ou distribution est strictement
      interdite.
    </p>

    <h4 className="font-semibold text-lg mt-6" data-id="element-107">7. Responsabilité</h4>
    <p data-id="element-108">
      Les guides proposés sont à titre informatif et éducatif. Ils ne remplacent
      pas un suivi médical ou psychologique professionnel. Les résultats peuvent
      varier d'une personne à l'autre.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal py-8 px-6" data-id="element-109">
        <div className="max-w-4xl mx-auto text-center" data-id="element-110">
          <div className="flex justify-center gap-6 mb-4" data-id="element-111">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white transition-colors text-sm underline underline-offset-2" data-id="element-112">
              Politique de Confidentialité
            </button>
            <span className="text-gray-600" data-id="element-113">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white transition-colors text-sm underline underline-offset-2" data-id="element-114">
              Conditions Générales de Vente
            </button>
          </div>
          <p className="text-gray-500 text-xs" data-id="element-115">
            © {new Date().getFullYear()} RE-NAISSANCE. Tous droits réservés.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-116">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black bg-opacity-60" onClick={() => setActiveModal(null)} data-id="element-117">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-118">
              <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-119">
                <h2 className="font-playfair text-xl text-burgundy" data-id="element-120">
                  {activeModal === 'privacy' ? 'Politique de Confidentialité' : 'Conditions Générales de Vente'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-charcoal transition-colors p-1" data-id="element-121">
                  <XIcon size={24} data-id="element-122" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-sm leading-relaxed" data-id="element-123">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}